// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2m25V","requiredAsterisk":"Info_requiredAsterisk__IbdXZ"};